export const GET_CONTACTS= 'GET_CONTACT';
export const SET_CONTACTS= 'SET_CONTACT';
export const SEND_NEW_MESSAGE = 'SEND_NEW_MESSAGE';
export const SET_NEW_MESSAGE = 'SET_NEW_MESSAGE';
export const SEND_MAIL_TO_QUIT_OPERATION = 'SEND_MAIL_TO_QUIT_OPERATION';
export const SET_OPERATION_LEFT_STATUS = 'SET_OPERATION_LEFT_STATUS';